import React from 'react'

const Error = () => {
  return (
    <div className=" my-auto mx-auto text-white text-3xl ">
     
        Error - 404 Not Found

    </div>
  )
}

export default Error
